import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    TemplateRef,
    ViewContainerRef
  } from '@angular/core';
  import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
  import { TemplatePortal } from '@angular/cdk/portal';
import { Subscription } from 'rxjs';
  
  @Directive({
    selector: '[appDropdownPortal]'
  })
  export class DropdownPortalDirective implements OnInit, OnDestroy {
    @Input() appDropdownPortal: TemplateRef<any>;
    @Input() originYIsTopOffsetY: number = 0;
    @Output() overlayClosed = new EventEmitter<void>();

    private overlayRef: OverlayRef;
    private scrollStrategySubscription: Subscription;

    constructor(
      private elementRef: ElementRef,
      private overlay: Overlay,
      private viewContainerRef: ViewContainerRef
    ) {}
  
    ngOnInit() {
        const overlayConfig = new OverlayConfig({
        positionStrategy: this.overlay
            .position()
            .flexibleConnectedTo(this.elementRef)
            .withPositions([
            { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
            { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: this.originYIsTopOffsetY }
            ]),

        scrollStrategy: this.overlay.scrollStrategies.close()
        });
    
        this.overlayRef = this.overlay.create(overlayConfig);
        const portal = new TemplatePortal(this.appDropdownPortal, this.viewContainerRef);
        this.overlayRef.attach(portal);

        this.scrollStrategySubscription = this.overlayRef.detachments().subscribe(() => {
          this.overlayClosed.emit();
        });
    }
  
    ngOnDestroy() {
      if (this.overlayRef) {
        this.overlayRef.dispose();
      }
      if (this.scrollStrategySubscription) {
        this.scrollStrategySubscription.unsubscribe();
      }
    }
  }
  